<template>
  <div>
    <div v-for="(desc, descIndex) in priceModel.displayFeaturesDescription"
         :key="priceModel.id + '_desc_' + descIndex">
      <div v-html="desc"/>
    </div>
  </div>
</template>


<script>

export default {
  name: "FinFeaturesList",
  props: {
    priceModel: {
      type: Object,
    },
  },
}
</script>

<style lang="scss" scoped>
li > span {
  font-size: 18px;
}

/* classes coming from the backend */
.bullet {

}

::v-deep .intro {
  min-height: 120px;
  @media only screen and (max-width: 1904px) {
    min-height: 180px;
  }
  @media only screen and (max-width: 1500px) {
    min-height: 265px;
  }
  @media only screen and (max-width: 1263px) {
    min-height: 375px;
  }
  @media only screen and (max-width: 959px) {
    min-height: 10px;
  }
  @media only screen and (max-width: 600px) {
    min-height: 10px;
  }
}

::v-deep .comment {

  min-height: 30px;
  @media only screen and (max-width: 1904px) {
    min-height: 50px;
  }
  @media only screen and (max-width: 1263px) {
    min-height: 70px;
  }
  @media only screen and (max-width: 959px) {
    min-height: 1px;
  }
  @media only screen and (max-width: 600px) {
    min-height: 1px;
  }
}

</style>
